import {
  put, takeLatest, all, select,
} from 'redux-saga/effects';
import { notification } from 'antd';
import WorkflowActions, { workflowActionTypes } from '@Actions/workflowActions';
import TrackerActions from '@Actions/trackerActions';
import WorkflowServices from '@Services/workflowServices';

/**
 * @param action
 */
function* _getPurchaseWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getPurchaseWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const purchaseWorkflows = yield WorkflowServices.getPurchaseWorkflows(tenantId);
    yield put(WorkflowActions.getPurchaseWorkflowsSuccess(purchaseWorkflows?.data));
    if (action.callback) {
      action.callback(purchaseWorkflows?.data);
    }
    yield put(WorkflowActions.getPurchaseWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getPurchaseWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_PURCHASE_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getPurchaseWorkflows() {
  yield takeLatest(workflowActionTypes.GET_PURCHASE_WORKFLOWS.REQUEST, _getPurchaseWorkflows);
}

/**
 * @param action
 */
function* _getVendorWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getVendorWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const vendorWorkflows = yield WorkflowServices.getVendorWorkflows(tenantId);
    yield put(WorkflowActions.getVendorWorkflowsSuccess(vendorWorkflows?.data));
    if (action.callback) {
      action.callback(vendorWorkflows?.data);
    }
    yield put(WorkflowActions.getVendorWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getVendorWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_VENDOR_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getVendorWorkflows() {
  yield takeLatest(workflowActionTypes.GET_VENDOR_WORKFLOWS.REQUEST, _getVendorWorkflows);
}

// Sales Estimate
function* _getSalesEstimateWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getSalesEstimateWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const salesEstimateWorkflows = yield WorkflowServices.getSalesEstimateWorkflows(tenantId);
    yield put(WorkflowActions.getSalesEstimateWorkflowsSuccess(salesEstimateWorkflows?.data));
    if (action.callback) {
      action.callback(salesEstimateWorkflows?.data);
    }
    yield put(WorkflowActions.getSalesEstimateWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getSalesEstimateWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_SALES_ESTIMATE_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

function* getSalesEstimateWorkflows() {
  yield takeLatest(workflowActionTypes.GET_SALES_ESTIMATE_WORKFLOWS.REQUEST, _getSalesEstimateWorkflows);
}

// Sales Order
function* _getSalesOrderWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getSalesOrderWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const salesOrderWorkflows = yield WorkflowServices.getSalesOrderWorkflows(tenantId);
    yield put(WorkflowActions.getSalesOrderWorkflowsSuccess(salesOrderWorkflows?.data));
    if (action.callback) {
      action.callback(salesOrderWorkflows?.data);
    }
    yield put(WorkflowActions.getSalesOrderWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getSalesOrderWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_SALES_ORDER_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

function* getSalesOrderWorkflows() {
  yield takeLatest(workflowActionTypes.GET_SALES_ORDER_WORKFLOWS.REQUEST, _getSalesOrderWorkflows);
}

// Packing Slip
function* _getPackingSlipWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getPackingSlipWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const PackingSlipWorkflows = yield WorkflowServices.getPackingSlipWorkflows(tenantId);
    yield put(WorkflowActions.getPackingSlipWorkflowsSuccess(PackingSlipWorkflows?.data));
    if (action.callback) {
      action.callback(PackingSlipWorkflows?.data);
    }
    yield put(WorkflowActions.getPackingSlipWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getPackingSlipWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_PACKING_SLIP_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

function* getPackingSlipWorkflows() {
  yield takeLatest(workflowActionTypes.GET_PACKING_SLIP_WORKFLOWS.REQUEST, _getPackingSlipWorkflows);
}


// Invoice
/**
 * @param action
 */
function* _getInvoiceWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getInvoiceWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const invoiceWorkflows = yield WorkflowServices.getInvoiceWorkflows(tenantId);
    yield put(WorkflowActions.getInvoiceWorkflowsSuccess(invoiceWorkflows?.data));
    if (action.callback) {
      action.callback(invoiceWorkflows?.data);
    }
    yield put(WorkflowActions.getInvoiceWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getInvoiceWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_INVOICE_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getInvoiceWorkflows() {
  yield takeLatest(workflowActionTypes.GET_INVOICE_WORKFLOWS.REQUEST, _getInvoiceWorkflows);
}

// Credit Note
/**
 * @param action
 */
function* _getCreditNoteWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getCreditNoteWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const creditNoteWorkflows = yield WorkflowServices.getCreditNoteWorkflows(tenantId);
    yield put(WorkflowActions.getCreditNoteWorkflowsSuccess(creditNoteWorkflows?.data?.[0]));
    if (action.callback) {
      action.callback(creditNoteWorkflows?.data?.[0]);
    }
    yield put(WorkflowActions.getCreditNoteWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getCreditNoteWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_CREDIT_NOTE_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getCreditNoteWorkflows() {
  yield takeLatest(workflowActionTypes.GET_CREDIT_NOTE_WORKFLOWS.REQUEST, _getCreditNoteWorkflows);
}

// Debit Note
/**
 * @param action
 */
function* _getDebitNoteWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getDebitNoteWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const debitNoteWorkflows = yield WorkflowServices.getDebitNoteWorkflows(tenantId);
    yield put(WorkflowActions.getDebitNoteWorkflowsSuccess(debitNoteWorkflows?.data?.[0]));
    if (action.callback) {
      action.callback(debitNoteWorkflows?.data?.[0]);
    }
    yield put(WorkflowActions.getDebitNoteWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getDebitNoteWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_DEBIT_NOTE_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getDebitNoteWorkflows() {
  yield takeLatest(workflowActionTypes.GET_DEBIT_NOTE_WORKFLOWS.REQUEST, _getDebitNoteWorkflows);
}

// Purchase Request
/**
 * @param action
 */
function* _getPurchaseRequestWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getPurchaseRequestWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const purchaseRequestWorkflows = yield WorkflowServices.getPurchaseRequestWorkflows(tenantId);
    yield put(WorkflowActions.getPurchaseRequestWorkflowsSuccess(purchaseRequestWorkflows?.data));
    if (action.callback) {
      action.callback(purchaseRequestWorkflows?.data);
    }
    yield put(WorkflowActions.getPurchaseRequestWorkflowsLoading(false));
    if (action.callback) {
      action.callback(purchaseRequestWorkflows?.data);
    }
  } catch (error) {
    yield put(WorkflowActions.getPurchaseRequestWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_PURCHASE_REQUEST_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getPurchaseRequestWorkflows() {
  yield takeLatest(workflowActionTypes.GET_PURCHASE_REQUEST_WORKFLOWS.REQUEST, _getPurchaseRequestWorkflows);
}

// Purchase Request
/**
 * @param action
 */
function* _getGoodsReceivingWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getGoodsReceivingWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const StockTransferWorkflows = yield WorkflowServices.getGoodsReceivingWorkflows(tenantId);
    yield put(WorkflowActions.getGoodsReceivingWorkflowsSuccess(StockTransferWorkflows?.data));
    if (action.callback) {
      action.callback(StockTransferWorkflows?.data);
    }
    yield put(WorkflowActions.getGoodsReceivingWorkflowsLoading(false));
    if (action.callback) {
      action.callback(StockTransferWorkflows?.data);
    }
  } catch (error) {
    yield put(WorkflowActions.getGoodsReceivingWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_GOODS_RECEIVING_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getGoodsReceivingWorkflows() {
  yield takeLatest(workflowActionTypes.GET_GOODS_RECEIVING_WORKFLOWS.REQUEST, _getGoodsReceivingWorkflows);
}

/**
 * @param action
 */
function* _createWorkflows(action) {
  try {
    yield put(WorkflowActions.createWorkflowsLoading(true));
    const address = yield WorkflowServices.createWorkflows(action.payload);
    if (address.success) {
      notification.open({
        type: 'success',
        message: 'Workflow Successfully added',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: address.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(WorkflowActions.createWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.createWorkflowsLoading(false));
    yield put(TrackerActions.trackAction(workflowActionTypes.CREATE_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createWorkflows() {
  yield takeLatest(workflowActionTypes.CREATE_WORKFLOWS.REQUEST, _createWorkflows);
}

/**
 * @param action
 */
function* _getPurchaseWorkflowSample(action) {
  try {
    yield put(WorkflowActions.getPurchaseWorkflowSampleLoading(true));
    const { tenantId, sampleType } = action;
    const samplePoWorkflow = yield WorkflowServices.getPurchaseWorkflowSample(tenantId, sampleType);
    yield put(WorkflowActions.getPurchaseWorkflowsSampleSuccess(samplePoWorkflow));
    if (!samplePoWorkflow) {
      notification.open({
        type: 'error',
        message: samplePoWorkflow.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = 'workflow';
      link.href = URL.createObjectURL(
        new Blob([samplePoWorkflow], { type: samplePoWorkflow.type }),
      );
      link.click();
    }
    yield put(WorkflowActions.getPurchaseWorkflowSampleLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getPurchaseWorkflowSampleLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_PURCHASE_WORKFLOW_SAMPLE.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getPurchaseWorkflowSample() {
  yield takeLatest(workflowActionTypes.GET_PURCHASE_WORKFLOW_SAMPLE.REQUEST, _getPurchaseWorkflowSample);
}

function* _createWorkflowV2(action) {
  try {
    yield put(WorkflowActions.createWorkflowV2Loading(true));
    const updatedWorkflow = yield WorkflowServices.createWorkflowV2(action?.payload);
    if (!updatedWorkflow?.success) {
      notification.open({
        type: 'error',
        message: updatedWorkflow.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'Approval workflow has been updated successfully',
        duration: 4,
        placement: 'top',
      });
    }
    if (action.callback) {
      action.callback();
    }
    yield put(WorkflowActions.createWorkflowV2Loading(false));
  } catch (error) {
    yield put(WorkflowActions.createWorkflowV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* createWorkflowV2() {
  yield takeLatest(workflowActionTypes.CREATE_WORKFLOW_V2.REQUEST, _createWorkflowV2);
}

// StockAdjustment
/**
 * @param action
 */
function* _getStockAdjustmentWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getStockAdjustmentWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const stockAdjustmentWorkflows = yield WorkflowServices.getStockAdjustmentWorkflows(tenantId);
    yield put(WorkflowActions.getStockAdjustmentWorkflowsSuccess(stockAdjustmentWorkflows?.data));
    if (action.callback) {
      action.callback(stockAdjustmentWorkflows?.data);
    }
    yield put(WorkflowActions.getStockAdjustmentWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getStockAdjustmentWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_STOCK_ADJUSTMENT_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getStockAdjustmentWorkflows() {
  yield takeLatest(workflowActionTypes.GET_STOCK_ADJUSTMENT_WORKFLOWS.REQUEST, _getStockAdjustmentWorkflows);
}

// StockTransfer
/**
 * @param action
 */
function* _getStockTransferWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getStockTransferWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const stockTransferWorkflows = yield WorkflowServices.getStockTransferWorkflows(tenantId);
    yield put(WorkflowActions.getStockTransferWorkflowsSuccess(stockTransferWorkflows?.data));
    if (action.callback) {
      action.callback(stockTransferWorkflows?.data);
    }
    yield put(WorkflowActions.getStockTransferWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getStockTransferWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_STOCK_TRANSFER_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getStockTransferWorkflows() {
  yield takeLatest(workflowActionTypes.GET_STOCK_TRANSFER_WORKFLOWS.REQUEST, _getStockTransferWorkflows);
}

/**
 *
 */

function* _getDeliveryChallanWorkflows(action) {
  const state = yield select();
  try {
    yield put(WorkflowActions.getDeliveryChallanWorkflowsLoading(true));
    const tenantId = state?.UserReducers.user?.tenant_info?.tenant_id;
    const deliveryChallanWorkflows = yield WorkflowServices.getDeliveryChallanWorkflows(tenantId);
    yield put(WorkflowActions.getDeliveryChallanWorkflowsSuccess(deliveryChallanWorkflows?.data));
    if (action.callback) {
      action.callback(deliveryChallanWorkflows?.data);
    }
    yield put(WorkflowActions.getDeliveryChallanWorkflowsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.getDeliveryChallanWorkflowsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.GET_DELIVERY_CHALLAN_WORKFLOWS.ERROR, {
      request: action,
      error,
    }));
  }
}

function* getDeliveryChallanWorkflows() {
  yield takeLatest(workflowActionTypes.GET_DELIVERY_CHALLAN_WORKFLOWS.REQUEST, _getDeliveryChallanWorkflows);
}



// add additional workflow approvals
function* _addAdditionalWorkflowApprovals(action) {
  try {
    yield put(WorkflowActions.addAdditionalWorkflowApprovalsLoading(true));
    const additionalWorkflowApprovals = yield WorkflowServices.addAdditionalWorkflowApprovals(action.payload);
    if (action.callback) {
      action.callback(additionalWorkflowApprovals);
    }
    yield put(WorkflowActions.addAdditionalWorkflowApprovalsLoading(false));
  } catch (error) {
    yield put(WorkflowActions.addAdditionalWorkflowApprovalsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(workflowActionTypes.ADD_ADDITIONAL_WORKFLOW_APPROVALS.ERROR, {
      request: action,
      error,
    }));
  }
}

function* addAdditionalWorkflowApprovals() {
  yield takeLatest(workflowActionTypes.ADD_ADDITIONAL_WORKFLOW_APPROVALS.REQUEST, _addAdditionalWorkflowApprovals);
}
export default function* workflowSaga() {
  yield all([
    getPurchaseWorkflows(),
    createWorkflows(),
    getVendorWorkflows(),
    getSalesEstimateWorkflows(),
    getSalesOrderWorkflows(),
    getPackingSlipWorkflows(),
    getInvoiceWorkflows(),
    getCreditNoteWorkflows(),
    getDebitNoteWorkflows(),
    getPurchaseRequestWorkflows(),
    getPurchaseWorkflowSample(),
    createWorkflowV2(),
    getStockAdjustmentWorkflows(),
    getStockTransferWorkflows(),
    getGoodsReceivingWorkflows(),
    addAdditionalWorkflowApprovals(),
    getDeliveryChallanWorkflows(),
  ]);
}
